module.exports = __webpack_public_path__ + "static/media/logo.42417a7a.png";